export function projectsLowestCommonFolderId(folderPaths: string[]) {
    // NO db calls in this function. all data is passed in.

    // lowest common folder ancestor id
    let lowestCommonFolder = null;

    if (folderPaths.length && folderPaths.every((folderPath) => !!folderPath?.length)) {
        const shortestPath = folderPaths.sort((a, b) => a.length - b.length)[0];

        for (let i = shortestPath.length - 1; i >= 0; i--) {
            // folderPath array is of format [rootProjectGroupId, leafProjectGroupId]
            const common = folderPaths.every((folderPath) => folderPath[i] === shortestPath[i]);
            if (common) {
                lowestCommonFolder = shortestPath[i];
                break;
            }
        }
    }

    return lowestCommonFolder; // null if workspace
}
